import { render, staticRenderFns } from "./ScoutFormGender.vue?vue&type=template&id=0b492826"
import script from "./ScoutFormGender.vue?vue&type=script&lang=js"
export * from "./ScoutFormGender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports